import React from "react";

import styled from "styled-components";

import Lottie from "react-lottie-player/dist/LottiePlayerLight";
import animationData from "./LoadingAnimation";

const Container = styled.div`
  ${({ theme }) => {
    if (theme.name === "dark") {
      return `
        svg {
          [stop-color="rgb(242,251,255)"] {
            stop-color: rgb(22,42,51);
          }
          [stop-color="rgb(249,253,255)"] {
            stop-color: rgb(22,32,37);
          }
          [stop-color="rgb(255,255,255)"] {
            stop-color: rgb(23,23,23);
          }
          [stop-color="rgb(21,105,255)"] {
            stop-color: rgb(0,175,255);
          }
          [stop-color="rgb(11,157,225)"] {
            stop-color: rgb(0,192,225);
          }
        }
      `;
    }
    return "";
  }}
`;

const LottieAnimation = () => (
  <Container>
    <Lottie
      animationData={animationData}
      style={{ width: "650px" }}
      play
      loop
    />
  </Container>
);

export default LottieAnimation;
